import { Link, useNavigate } from "react-router-dom";
// import Icon from "../assets/images/icon.png";

const Footer = () => {
  const navigate = useNavigate();

  const handleContactClick = () => {
    navigate("/contact");
    window.scrollTo(0, 0);
  };

  return (
    <footer className="bg-[#1B3144] text-white py-8">
      {/* Top Newsletter Section */}
      <div className="container mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-16">
          <div className="">
            <div className="flex items-center gap-4 mb-6">
              {/* <img src={Icon} alt="Wonderful Eight" className="h-6" /> */}
              <span className="text-white text-2xl font-medium">
                Wonderful Eight
              </span>
            </div>

            <p className="text-white mb-6 text-lg">
              Connect directly with leading architecture firms. Find contact
              details for global innovators in design and engineering below.
            </p>

            <div className="max-w-md">
              <button
                onClick={handleContactClick}
                className="w-full flex items-center justify-between px-6 py-4 border border-white/30 hover:border-white/50 transition-colors cursor-pointer"
              >
                <span>Reach out to us</span>
                <svg className="w-5 h-5" viewBox="0 0 20 20" fill="none">
                  <path
                    d="M4 10H16M16 10L10 4M16 10L10 16"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>

            <p className="text-white/60 text-sm mt-3 max-w-md">
              By contacting us, you agree to our Privacy Policy and consent to
              receive responses or updates related to your inquiry.
            </p>
          </div>

          {/* Main Footer Grid */}
          <div className="col-span-2 grid grid-cols-2 md:grid-cols-3 gap-y-12 w-full gap-x-16">
            {/* Company */}
            <div>
              <h3 className="text-white font-normal text-lg mb-6 border-b-2 border-white pb-4">
                Company
              </h3>
              <ul className="space-y-4">
                <li>
                  <Link to="/" className="text-white/80 hover:text-white">
                    Home
                  </Link>
                </li>
                <li>
                  <Link
                    to="/expertise"
                    className="text-white/80 hover:text-white"
                  >
                    Our Expertise
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact"
                    className="text-white/80 hover:text-white"
                  >
                    Contact
                  </Link>
                </li>
                <li>
                  <Link to="/blog" className="text-white/80 hover:text-white">
                    Blog
                  </Link>
                </li>
              </ul>
            </div>

            {/* Firms */}
            <div className="hidden md:block col-span-2">
              <h3 className="text-white font-normal text-lg mb-6 border-b-2 border-white pb-4">
                Firms
              </h3>
              <div className="grid grid-cols-2 gap-4">
                <ul className="space-y-4">
                  <li>
                    <Link
                      to="/firms/aecom"
                      className="text-white/80 hover:text-white"
                    >
                      AECOM
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/firms/arcadis"
                      className="text-white/80 hover:text-white"
                    >
                      Arcadis
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/firms/foster"
                      className="text-white/80 hover:text-white"
                    >
                      Foster
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/firms/gensler"
                      className="text-white/80 hover:text-white"
                    >
                      Gensler
                    </Link>
                  </li>
                </ul>
                <ul className="space-y-4">
                  <li>
                    <Link
                      to="/firms/hdr"
                      className="text-white/80 hover:text-white"
                    >
                      HDR
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/firms/nikken"
                      className="text-white/80 hover:text-white"
                    >
                      Nikken Sekkei
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/firms/perkins"
                      className="text-white/80 hover:text-white"
                    >
                      Perkins Eastman
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/firms/skidmore"
                      className="text-white/80 hover:text-white"
                    >
                      Skidmore, Owings & Merrill
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-white/20 pt-4 mt-4">
          <div className="flex flex-col md:flex-row justify-center items-center gap-4">
            <p className="text-white/60 text-sm">
              © {new Date().getFullYear()} Wonderful Eight. All rights reserved.
            </p>
            {/* <div className="flex items-center gap-8">
              <Link
                to="/privacy"
                className="text-white/60 hover:text-white text-sm"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms"
                className="text-white/60 hover:text-white text-sm"
              >
                Terms of Service
              </Link>
              <button className="text-white/60 hover:text-white text-sm">
                Cookies Settings
              </button>
            </div> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
